import axios from 'axios'

const isDev = process.env.NODE_ENV === 'development'
export const url = isDev ? 'http://localhost:5000/api' : '/api'

// export const url = 'http://fps-agm.gr/api'

console.log(`Using base url: ${url}`)

export default axios.create({
    baseURL: url
});
